import './index.scss'

import React from 'react'
import T from 'prop-types'
import BEMHelper from 'react-bem-helper'

const bem = new BEMHelper('hero')

export default function Hero({ children, image, aspect, spaceless }) {
  return (
    <section {...bem('', { spaceless })}>
      <div {...bem('content')}>{children}</div>

      {image && <img src={image} alt={image.alt || ''} {...bem('asset')} />}
    </section>
  )
}

Hero.propTypes = {
  children: T.any.isRequired,
  image: T.object,
  aspect: T.string,
  spaceless: T.bool,
}
